export interface Testimonial {
  id: string;
  name: string;
  role: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 't-1',
    name: '李先生',
    role: '企业管理者 · 42岁',
    content: '这个网站的分析让我第一次从客观的学术视角理解了婚外情现象的复杂性。不再是简单的道德评判，而是真正帮助我理解了关系中出现问题的信号和可能的预防方向。',
    rating: 5,
  },
  {
    id: 't-2',
    name: '王女士',
    role: '心理咨询师 · 35岁',
    content: '作为从业者，我非常欣赏这个网站对心理学理论的准确应用。文章对依恋理论、自恋人格的分析都非常专业，同时保持了大众可读性。已经推荐给了多位来访者。',
    rating: 5,
  },
  {
    id: 't-3',
    name: '张先生',
    role: '大学教师 · 48岁',
    content: '网站对社会学视角的运用令人印象深刻。将"人妻猎人"现象放在城市化、个人主义和制度变迁的大背景下分析，提供了比个案故事更有价值的系统性洞察。',
    rating: 5,
  },
  {
    id: 't-4',
    name: '陈女士',
    role: '婚姻咨询师 · 39岁',
    content: '婚姻保护板块的文章非常实用。特别是关于情感账户日常充值和边界意识建立的部分，我已经将这些框架融入了我的咨询工作中，来访者反馈很好。',
    rating: 5,
  },
  {
    id: 't-5',
    name: '刘先生',
    role: '职场人士 · 36岁',
    content: '最初是被标题吸引进来的，但读了文章后发现内容远比标题严肃和深入。特别是关于社交媒体如何影响婚姻关系的分析，让我重新审视了自己的社交习惯。网站值得认真对待。',
    rating: 4,
  },
  {
    id: 't-6',
    name: '赵女士',
    role: '全职主妇 · 33岁',
    content: '感谢这个平台提供的客观视角。在经历婚姻危机时，这里的文章帮助我理解了问题的复杂性，而不是简单地指责或自责。重建信任的指南尤其给了我很多实际的行动方向。',
    rating: 5,
  },
];

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  image: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: 'tm-1',
    name: '陈思远',
    role: '创始人 & 主编',
    bio: '社会学博士，专注都市文化与亲密关系研究十余年。曾在多所高校担任客座讲师，著有多篇关于当代婚姻变迁的学术论文。创立本平台的初衷是为公众提供一个理解复杂情感现象的知识性窗口。',
    image: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20scholar%20portrait%2C%20warm%20lighting%2C%20minimalist%20studio%20background%20in%20beige%20tones%2C%20intellectual%20style%2C%20clean%20professional%20headshot&width=400&height=400&seq=team-01&orientation=squarish',
  },
  {
    id: 'tm-2',
    name: '林雨桐',
    role: '资深撰稿人',
    bio: '临床心理学硕士，国家二级心理咨询师。专注于依恋理论、婚姻治疗与情感创伤修复领域。她的文章以专业的心理学功底和温暖的人文关怀并重而受到读者喜爱。',
    image: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20female%20psychologist%20portrait%2C%20warm%20lighting%2C%20minimalist%20studio%20background%20in%20coral%20tones%2C%20gentle%20expression%2C%20clean%20professional%20headshot&width=400&height=400&seq=team-02&orientation=squarish',
  },
  {
    id: 'tm-3',
    name: '王建平',
    role: '社会评论员',
    bio: '资深媒体人，前主流媒体社会新闻主编。擅长从社会结构与制度变迁视角解读个体行为。他的分析以数据支撑和宏观视野著称，为平台内容提供了不可或缺的社会学维度。',
    image: 'https://readdy.ai/api/search-image?query=professional%20Chinese%20male%20journalist%20portrait%2C%20warm%20lighting%2C%20minimalist%20studio%20background%20in%20terracotta%20tones%2C%20confident%20expression%2C%20clean%20professional%20headshot&width=400&height=400&seq=team-03&orientation=squarish',
  },
];